import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useApiGet } from "@redriver/cinnamon";
import SimpleMessage from "components/SimpleMessage";
import { storeAuth } from "authSession";

const useQuery = () => new URLSearchParams(useLocation().search);

const AzureAdSigninPage = () => {
  const query = useQuery();
  const history = useHistory();

  const code = query.get("code");
  const state = query.get("state");
  const embedPopupMode = query.get("embed-popup") == "true";

  const a = useApiGet(
    "api/auth/azure-ad-signin?code=" +
      code +
      "&state=" +
      state +
      (embedPopupMode ? "&embedded=true" : "")
  );
  const [{ busy, success, error, response }] = a;

  useEffect(() => {
    if (success) {
      window.auth = response;
      // So a reload picks the token back up instead of going round Azure AD
      // again — which on a dev server rebuilding every few seconds is enough
      // sign-ins for the tenant to start throttling them.
      storeAuth(response);

      if (!embedPopupMode) {
        history.push("/");
        return;
      }

      // embed mode

      // code ok.. subscribe for messages and send get-origin
      window.addEventListener(
        "message",
        function (event) {
          if (
            !event.data.embedstate ||
            event.data.embedstate != window.embedstate
          )
            return;
          fetch(
            (process.env.LOCAL_BORG_SERVER
              ? "http://localhost:5001/api/"
              : "https://borg.red-river.app/api/") + "auth/validate-origin",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ origin: event.origin }),
            }
          )
            .then((response) => response.json())
            .then((data) => {
              if (data.isValid) {
                // all good!
                window.validatedParentOrigin = event.origin;
                history.push("/embedded");
              } else {
                window.opener.postMessage({ type: "auth-bad" }, event.origin);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              window.opener.postMessage({ type: "auth-bad" }, event.origin);
            });
        },
        false
      );

      window.embedstate = Math.random();
      window.opener.postMessage(
        { type: "get-origin", embedstate: window.embedstate },
        "*"
      );
    }
  }, [busy, success, error, response]);

  return <SimpleMessage>Confirming your identity</SimpleMessage>;
};

export default AzureAdSigninPage;
